<div class="panel">
  <mat-button-toggle-group
    aria-label="Byte view"
    value="HEX"
    appearance="legacy"
    hideSingleSelectionIndicator
    #mode="matButtonToggleGroup"
    >
    <mat-button-toggle value="HEX">HEX</mat-button-toggle>
    <mat-button-toggle value="BINARY">BINARY</mat-button-toggle>
    <mat-button-toggle value="TEXT">TEXT</mat-button-toggle>
  </mat-button-toggle-group>
</div>
<div #tableHex>
  @if (mode.value === 'TEXT') {
    <div
      style="font-family: monospace"
      >
      <pre>
        {{toTextPre(hexCode)}}
        <!-- <span style="word-wrap: break-word;" *ngFor="let row of hexCode">
        <ng-container  *ngFor="let char of row">{{ toCharFromHex(char) }}</ng-container>
      </span> -->
    </pre>
  </div>
}
@if (mode.value != 'TEXT') {
  @for (
    row of mode.value === 'BINARY' ? binaryCode : hexCode; track
    row; let rowId = $index) {
    <div
      [id]="'row-' + rowId"
      style="display: flex; justify-content: flex-start; font-family: monospace"
      >
      <div class="col-index" style="background-color: lightgray">
        {{ indexColumnValue(rowId, mode.value === "BINARY" ? 8 : 16) }}
      </div>
      @for (hex of row; track hex; let colId = $index) {
        <div
          class="col-hex"
          [class.selected]="isSelected(rowId, colId, mode)"
          (click)="onClick(rowId, colId, mode)"
          >
          {{ mode.value === "BINARY" ? hexToBinary(hex) : hex }}
        </div>
      }
      <span style="width: 0.5rem"></span>
      @for (char of row; track char; let colId = $index) {
        <span
          class="col-char"
          (click)="onClick(rowId, colId, mode)"
          [class.selected]="isSelected(rowId, colId, mode)"
          >{{ toCharFromHex(char) }}</span
          >
        }
      </div>
    }
  }
</div>
